import * as t from '../actionTypes'

export const wsDisconnected = () => ({
  type: t.WS_DISCONNECTED,
  meta: { done: true }
})
